import { deepmerge } from '../../common/functions';
import { TransportLayerClientRequestHeader } from './util/TransportLayerClientRequestHeader';
var AbstractMdg2Request = (function () {
    function AbstractMdg2Request(message, version) {
        this.header = new TransportLayerClientRequestHeader();
        this.coreMembers = {
            Message: message,
            Version: version
        };
        this.members = {};
    }
    AbstractMdg2Request.prototype.getPtlMessage = function () {
        var headerAttribute = { header: this.header.getPtlMessage() };
        return deepmerge(headerAttribute, this.coreMembers, this.members);
    };
    return AbstractMdg2Request;
}());
export { AbstractMdg2Request };
//# sourceMappingURL=AbstractMdg2Request.js.map